// Remembers that this student agreed to the chat's terms, until the school year turns over
// (1 June, the start of the Philippine school year), so returning students aren't asked again
// on every page load. Kept per student (the id inside the sign-in token) on this device.

const KEY_PREFIX = 'annaTermsAgreed:';

const userIdFromToken = () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.user_id || payload.sub || null;
  } catch {
    return null;
  }
};

/** The 1 June after a date: when an agreement stops counting. */
export const termsExpiry = (agreedAt) => {
  const date = new Date(agreedAt);
  const juneThisYear = new Date(date.getFullYear(), 5, 1);
  return date < juneThisYear ? juneThisYear : new Date(date.getFullYear() + 1, 5, 1);
};

export const rememberTerms = (now = new Date()) => {
  const id = userIdFromToken();
  if (!id) return;
  try {
    localStorage.setItem(`${KEY_PREFIX}${id}`, now.toISOString());
  } catch {
    // Storage blocked: the student just sees the terms again next time
  }
};

export const termsRemembered = (now = new Date()) => {
  const id = userIdFromToken();
  if (!id) return false;
  try {
    const saved = localStorage.getItem(`${KEY_PREFIX}${id}`);
    if (!saved) return false;
    return now < termsExpiry(saved);
  } catch {
    return false;
  }
};
